var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfigurations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0C9.69837 0 7 2.69837 7 6C7 6.52599 7.15748 6.99416 7.28516 7.47266L2.63477 12.123C1.12945 12.5138 0 13.879 0 15.5C0 17.4212 1.57885 19 3.5 19C5.12102 19 6.48618 17.8706 6.87695 16.3652L11.5273 11.7148C12.0058 11.8425 12.474 12 13 12C16.3016 12 19 9.30163 19 6C19 5.22014 18.839 4.48338 18.5781 3.81641L18.0215 2.39258L15.707 4.70703H15.7051C15.5068 4.9059 15.2581 5 15 5C14.7419 5 14.4933 4.9059 14.2949 4.70703H14.293C13.894 4.3081 13.894 3.6919 14.293 3.29297L16.6074 0.978516L15.1836 0.421875C14.5166 0.160989 13.7799 0 13 0ZM12.8145 2.03711C11.7781 3.20885 11.7591 5.00133 12.8789 6.12109C13.4605 6.70422 14.2341 7 15 7C15.7087 7 16.3991 6.68739 16.9629 6.1875C16.8605 8.31448 15.1538 10 13 10C12.4939 10 12.008 9.89596 11.5449 9.71484L10.9355 9.47656L6.5625 13.8496C6.23707 13.2517 5.74831 12.7629 5.15039 12.4375L9.52344 8.06445L9.28516 7.45508C9.10404 6.99205 9 6.50614 9 6C9 3.84554 10.6865 2.13849 12.8145 2.03711ZM3.5 14C4.34027 14 5 14.6597 5 15.5C5 16.3403 4.34027 17 3.5 17C2.65973 17 2 16.3403 2 15.5C2 14.6597 2.65973 14 3.5 14Z",
    fill: "#A1AAB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigurations);
export default __webpack_public_path__ + "static/media/configurations.4d6ebe23.svg";
export { ForwardRef as ReactComponent };